import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ModalComponent} from "../modal/modal.component";
import {concat, Observable} from "rxjs";
import {finalize, tap} from "rxjs/operators";
import * as LessonsV3 from '../../model/v3/lessons';
import {ManagerColV3RestService} from "../../services/rest/v3/manager-col-v3-rest.service";

@Component({
    selector: 'app-student-bundle-extend',
    templateUrl: './student-bundle-extend.component.html',
    styleUrls: ['./student-bundle-extend.component.scss'],
    standalone: false
})
export class StudentBundleExtendComponent implements OnInit {

  @Input()
  studentId: number;

  @Input()
  schoolId: number;

  @ViewChild('modalComponent')
  modal: ModalComponent

  @Output()
  bundleUpdated = new EventEmitter<LessonsV3.LessonBundle>()

  constructor(
    private managerRest: ManagerColV3RestService
  ) { }

  model: LessonsV3.LessonBundle | null;
  bundle: LessonsV3.LessonBundle;
  complete: boolean;
  error: any;
  inProgress = false;
  private expiryDateChanged = false;

  ngOnInit(): void {
    this.modal.show(true);
  }

  onExpiryDateChange(expiryDate: any){
    if (!this.model) {
      return;
    }
    this.model.expiryDate = expiryDate
    this.expiryDateChanged = true;
  }

  openFor(bundle: LessonsV3.LessonBundle) {
    this.model = {...bundle};
    this.complete = false;
    this.error = null;
    this.expiryDateChanged = false;
    this.bundle = bundle;
    this.modal.show(true);
  }

  submitUpdate() {
    if (!this.model?.expiryDate) {
      return;
    }
    const updatedItem = this.bundle;
    const expiryDate = this.model.expiryDate;
    const note = this.model.note ?? '';
    // expiry date and note have separate endpoints; send only what changed,
    // one after another, so a failure stops the remaining request
    const requests: Observable<void>[] = [];
    if (this.expiryDateChanged) {
      requests.push(this.managerRest.updateStudentLessonBundleExpiry(
        this.schoolId,
        this.studentId,
        updatedItem.id,
        new Date(expiryDate as unknown as string)
      ).pipe(tap(() => updatedItem.expiryDate = expiryDate)));
    }
    if (note !== (updatedItem.note ?? '')) {
      requests.push(this.managerRest.updateStudentLessonBundleNote(
        this.schoolId,
        this.studentId,
        updatedItem.id,
        note
      ).pipe(tap(() => updatedItem.note = note)));
    }

    let anyUpdated = false;
    this.inProgress = true;
    concat(...requests).pipe(
      finalize(() => {
        this.inProgress = false;
        this.complete = true;
        this.model = null;
        this.bundle = null;
        if (anyUpdated) {
          this.bundleUpdated.emit(updatedItem);
        }
      })
    ).subscribe(
      {
        error: err => this.error = err.userMessage ? err.userMessage : err.message,
        next: _ => anyUpdated = true
      }
    )
  }
}
